import type React from "react";
import {Button} from "reactstrap";

interface ActionBarButtonProps {
  children: React.ReactNode;
  active?: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export function ActionBarButton({children, active, onClick, disabled}: ActionBarButtonProps) {
  return (
    <Button
      type="button"
      size="sm"
      color={active ? "success" : "transparent"}
      style={{
        borderRadius: "14px",
        paddingLeft: "16px",
        paddingRight: "16px",
        position: "relative",
      }}
      active={active}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Button>
  );
}
